import React, {useState, useCallback, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';
import { View } from 'react-native';
import { CREATE_BUYER, UPDATE_BUYER } from './queries';

const EditBuyer = ({setShowModal, refetch, buyer, saleAssetId}) => {
  const [submitting, setSubmitting] = useState();
  const [updateBuyer] = useMutation(UPDATE_BUYER, {
    onCompleted: () => {
      if(refetch) {
        refetch();
      }
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    input['saleAssetId'] = saleAssetId;
    updateBuyer({ variables: input });
  });

  const { control, handleSubmit, register, setValue, formState: { errors } } = useForm({
    defaultValues: {
      id: buyer?.id,
      name: buyer?.name || '',
      companyName: buyer?.companyName || '',
      street: buyer?.street || '',
      city: buyer?.city || '',
      state: buyer?.state || '',
      postalCode: buyer?.postalCode?.formatted !== null ? buyer?.postalCode?.formatted : '',
      phoneNumber: buyer?.phoneNumber?.formatted !== null ? buyer?.phoneNumber?.formatted : '',
      email: buyer?.email || '',
      notes: buyer?.notes || ''
    }
  });

  return (
    <View>
      {submitting ?
        <DataState.Loading /> :
        <View>
          <Input.Text
            label="Name:"
            name="name"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Company Name:"
            hint="At least one of name or company name is required."
            name="companyName"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Street:"
            name="street"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="City:"
            name="city"
            control={control}
            errors={errors}
          />
          <Input.StatePicker
            label="State:"
            name="state"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Zip:"
            name="postalCode"
            control={control}
            errors={errors}
          />
          <Input.Phone
            label="Phone Number:"
            name="phoneNumber"
            control={control}
            errors={errors}
          />
          <Input.Phone
            label="Email:"
            name="email"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Notes:"
            name="notes"
            control={control}
            errors={errors}
          />
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Update Buyer" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default EditBuyer;
